<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                        <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                        <div class="flex-1">
                            <h3 class="m-0">Detail Karyawan</h3>
                            <p class="mb-0">Daftar karyawan disini ya gan :)</p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Nama</label>
                                        <h3 class="bmd-label-floating m-0" >{{data.params.knama}}</h3>
                                        <p class="bmd-label-floating mb-0" >{{data.params.hp}}</p>
                                        <p class="bmd-label-floating mb-0" >{{data.params.jabatan}}</p>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Gaji</label>
                                        <p class="bmd-label-floating mb-0" >{{myGlobal.ribu(data.params.gaji_pokok)}}</p>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Sisa Bon</label>
                                        <p class="bmd-label-floating mb-0 text-danger" >{{myGlobal.ribu(data.params.sisa_bon)}}</p>
                                    </div>
                                    <div class="form-group" v-show="data.params.username != null">
                                        <label class="bmd-label-floating">Username</label>
                                        <p class="bmd-label-floating mb-0 text-info" ><strong>{{"Kary-"+data.params.username}}</strong></p>
                                        <small>Untuk login pake ini ya, passwordnya tadi yg di ketik itu. Kalo lupa ya reset aja :)</small>
                                    </div>
                                    <div class="form-group" v-show="data.params.rtrw_id != 'non-rtrw'">
                                        <label class="bmd-label-floating">Singkron dengan Kang Tagih</label>
                                        <p class="bmd-label-floating mb-0 text-info" ><strong>{{data.kangtagih}}</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
			<div class="row">
				<div class="col-md-12">
                    <button class="btn btn-info" @click="data.historyUpgrade = true">
                        History Absen
                    </button>
                    <button class="btn btn-success" @click="data.historyUpgrade = false">
                        History Gajian
                    </button>

				</div>
			</div>
            
            <div class="row">
                <div class="col-md-12">
                    <div class="card" v-if="data.historyUpgrade">
                        <div class="card-header card-header-info">
                            <div class="row">
                                <div class="col-md-6">
                                    <h4 class="card-title ">History Absen</h4>
                                </div>
                                <div class="col-md-6" v-show="false">
                                    <h2 class="card-title text-right">{{data.filtered}}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                <th width="40px">No.</th>
                                <th>Tanggal</th>
                                <th>Masuk</th>
                                <th>Pulang</th>
                                <th>Telat</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in rincian.data.list">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            {{ myGlobal.tglIndo(u.tanggal) }}
                                        </td>
                                        <td>
                                            {{ myGlobal.jamIndo(u.masuk) }}
                                        </td>
                                        <td>
                                            {{ myGlobal.jamIndo(u.pulang) }}
                                        </td>
                                        <td>{{u.telat}} menits</td>
                                    </tr>

                                    <tr v-show="rincian.data.list.length == 0">
                                        <td></td>
                                        <td>Tidak ada Data</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>

                    <div class="card" v-else>
                        <div class="card-header card-header-success">
                            <div class="row">
                                <div class="col-md-6">
                                    <h4 class="card-title ">History Gajian</h4>
                                </div>
                                <div class="col-md-6" v-show="false">
                                    <h2 class="card-title text-right">{{data.filtered}}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                    <th width="40px">No.</th>
                                    <th>Gaji Bulan</th>
                                    <th>Total</th>
                                    <th>Bayar BON</th>
                                    <th>Sisa Gaji</th>
                                    <th>Tanggal Gajian</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in rincian.data.listBayar">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ myGlobal.BulanOnly(u.gaji_bulan) }}</td>
                                        <td>{{ myGlobal.ribu(u.gaji) }}</td>
                                        <td>{{ myGlobal.ribu(u.bayar_bon) }}</td>
                                        <td>{{ myGlobal.ribu(u.sisa_gaji) }}</td>
                                        <td>{{ myGlobal.tglIndo(u.tanggal) }}</td>
                                    </tr>
                                </tbody>
                                <tbody v-show="rincian.data.listBayar.length == 0">
                                    <td></td>
                                    <td>Tidak ada Data</td>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/InterfaceAbsensi' 

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
	const data = reactive({
        params: '',
        historyUpgrade: true,
        kangtagih: null,
    })

	const rincian = {
      	data: reactive({
            list: [],
            listBayar: []
      	}),
		get() {
			var datac = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
                mid: data.params.mid,
        	};
				
			var apiUrl = inter.MitraBw();
			myGlobal.call(datac,apiUrl).then(x => {
				if (x.status == true) {
                    rincian.data.list = x.data
				} else {
					//alert(x.pesan);
				}
			})
		},
        historyAbsenFunc() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
                id: data.params.id,
                limit: 7,
                page: 0
            };
        
            var apiUrl = inter.historyAbsen();
            myGlobal.callAbsensi(datax,apiUrl).then(x => {
            
                // myGlobal.loger(x);

                //data.loading = false;

                if (x.status == true) {
                    this.data.list = x.data;
                } else {
                    theGet.data.List = null;
                }
            })
        },
        historyGajianFunc() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
                id: data.params.id,
                limit: 7,
                page: 0
            };
        
            var apiUrl = inter.historyGajian();
            myGlobal.callAbsensi(datax,apiUrl).then(x => {
            
                //myGlobal.loger(x);

                //data.loading = false;

                if (x.status == true) {
                    this.data.listBayar = x.data;
                } else {
                    theGet.data.listBayar = null;
                }
            })
        },
        KangTagih() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
                tokenb: 'TangTung '+sessionStorage.getItem('myToken'),
                id: data.params.rtrw_id
            };
        
            var apiUrl = inter.getKangTagih();
            myGlobal.callAbsensi(datax,apiUrl).then(x => {
            
                //myGlobal.loger(x);

                //data.loading = false;

                if (x.status == true) {
                    var d = x.data;

                    data.kangtagih = d[0].nama;
                    
                } else {
                    
                }
            })
        },
    }
    return {
      data,
      myGlobal,
      rincian
    }

  },
  mounted () {

    document.title = "Detail Karyawan"; 

    var param = this.$route.params;
    this.data.params = param.data;

    //console.log(JSON.stringify(this.data.params));

    this.rincian.historyAbsenFunc();
    this.rincian.historyGajianFunc();

    this.rincian.KangTagih();
  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/absensi/karyawan/detail.vue